export enum ExistingDocumentOption {
    AddToDocument = 1,
    ReplaceDocument,
    CreateHistoricVersion
}